import { Input as InputChakra } from '@chakra-ui/react'
import { ChangeEventHandler, FocusEventHandler, useEffect, useState } from 'react';
import * as CSS from "csstype";

export type InputProps = {
    placeholder?: string;
    onChange?: ChangeEventHandler;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
    defaultValue?: string;
    textAlign?: CSS.Property.TextAlign;
    borderTopRightRadius?: CSS.Property.BorderTopRightRadius;
    borderBottomRightRadius?: CSS.Property.BorderBottomRightRadius;
    variant?: 'filled' | 'unstyled' | 'flushed' | 'outline';
    background?: string;
  padding?: number | number[];
    type?: string;
    marginRight?: number
    marginBottom?: number;
    disabled?: boolean;
}

const Input = ({variant = 'unstyled', onFocus, onBlur, defaultValue, onChange, placeholder, type = 'text', background, disabled = false, ...rest}: InputProps) => {

    const [internalValue, setInternalValue] = useState(defaultValue);

    useEffect(() => {
        setInternalValue(defaultValue);
    }, [defaultValue])
    
    return (
        <InputChakra
            onBlur={onBlur}
            type={type}
            disabled={disabled}
            onFocus={onFocus}
            value={internalValue}
            background={variant ==='filled' ? '#F9F9F9': background ? background : ''}
            borderRadius="45px"
            variant={variant}
            placeholder={placeholder}
            onChange={onChange}
            defaultValue={defaultValue}
            {...rest}
        />
    );
}

export {Input};